import findIndex from 'lodash/findIndex';

export class ReportEditService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        this.serviceAreaListResourceUrl = this.apiService.getResourceUrl('cms/progress-report/service-area');
        this.programYearResourceUrl = this.apiService.getResourceUrl('fiscal-year');
        this.addProgramYearResourceUrl = this.apiService.getResourceUrl('cms/fiscal-year');

        this.serviceAreaListResource = this.$resource(this.serviceAreaListResourceUrl);
        this.programYearResource = this.$resource(this.programYearResourceUrl);
        this.addProgramYearResource = this.$resource(this.addProgramYearResourceUrl);
    }

    getServiceAreaList() {
        const promise = this.serviceAreaListResource.get().$promise;

        return promise.then(({ data }) => this._getServiceAreaList(data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getPrgoramYears() {
        const currentYear = this._getCurrentYear();
        const promise = this.programYearResource.get().$promise;

        return promise
            .then(({ data }) => this._getProgramYears(data))
            .then(fiscalYearList => findIndex(fiscalYearList, { name: currentYear }) === -1 ? this.addProgramYear(currentYear) : fiscalYearList)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    addProgramYear(fiscalYear) {
        const promise = this.addProgramYearResource.save({ fiscal_year: fiscalYear }).$promise;

        return promise
            .then(({ data }) => this._getProgramYears(data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });;
    }

    getReportDetailsObject({ data }) {
        return this._getProgressReportDetailsdata(data)
    }

    setProgressReportDetailsData(details) {
        return {
            title: details.title,
            service_area_id: details.selectedServiceAreaId,
            fiscal_year_id: details.selectedProgramYearId,
            pdf: details.uuid
        }
    }

    _getProgressReportDetailsdata(details) {
        return {
            id: details.content_id,
            title: details.title,
            name: details.mask_name,
            selectedProgramYearId: details.fiscal_year_id,
            from: details.start_from,
            to: details.end_to,
            selectedServiceAreaId: details.service_area_id,
            countyName: details.county_name,
            image: this.apiService.getImageUrl(details.image),
            uuid: details.pdf,
            url: this.apiService.getResourceUrl(`files/pdf/${details.pdf}`),
        };
    }

    _getServiceAreaList(list) {
        return list.map((details) => {
            return {
                id: details.service_area_id,
                name: `${details.name} (${details.state_code})`
            }
        });
    }

    _getProgramYears(list) {
        return list.map((details) => {
            return {
                id: details.fiscal_year_id,
                name: details.fiscal_year
            }
        });
    }

    _getCurrentYear() {
        return new Date().getFullYear();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/report-edit/report-edit.service.js